module.exports = __webpack_public_path__ + "0396ab2bedb2d56c8bb320d5f485be6f.png";


/*****************
 ** WEBPACK FOOTER
 ** ./src/assets/images/city-19.png
 ** module id = 1009
 ** module chunks = 0
 **/